import { send_request } from './Request';

export const loadDraftProject = (projectId) =>
  send_request(`project-service/project/${projectId}/canvas`, '', {}, 'GET');

export const loadPublishedProject = (projectId) =>
  send_request(`project-service/project/${projectId}/canvas/published`, '', {}, 'GET');

export const loadProjectByVersion = (projectId, version) =>
  send_request(`project-service/project/${projectId}/canvas/version/${version}`, '', {}, 'GET');

export const saveCanvasEvent = (projectId, event) =>
  send_request(`project-service/project/${projectId}/canvas/save`, event, {}, 'POST');

export const loadNextComponents = (projectId, componentId) =>
  send_request(`project-service/project/${projectId}/canvas/next-components/${componentId}`, '', {}, 'GET');
